import MembershipPlanForm, {
  IMemberShipPlanFormProps,
} from '../../../../UI/Form/MembershipPlanForm/membershipPlanForm';
const SubscriptionCreateMembershipPlanForm = ({
  disabled,
  subscriptionRenewalSuggestionPlans,
  ...props
}: IMemberShipPlanFormProps) => (
  <MembershipPlanForm
    {...props}
    disabled={disabled}
    additionalData={subscriptionRenewalSuggestionPlans}
  />
);

export default SubscriptionCreateMembershipPlanForm;
